import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { useCheckoutCartStore } from "@faire/retailer-visitor-shared/components/Checkout/models/store/CheckoutCartStore";
import { useCheckoutShippingAddressStore } from "@faire/retailer-visitor-shared/components/Checkout/models/store/CheckoutShippingAddressStore";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useQuery as useGetConductorComponentFromToken } from "@faire/web-api--source/api/conductor/component/componentToken/get-hooks";
import { QueryParameters as ConductorComponentQueryParameters } from "@faire/web-api--source/api/conductor/component/get";
import { useQuery as useGetConductorComponentQuery } from "@faire/web-api--source/api/conductor/component/get-hooks";
export var useConductorComponentWithCartData = function(surface) {
    var address = useCheckoutShippingAddressStore([
        "address"
    ]).address;
    var _useCheckoutCartStore = useCheckoutCartStore([
        "cartToken",
        "cartBrandTokens"
    ]), cartToken = _useCheckoutCartStore.cartToken, cartBrandTokens = _useCheckoutCartStore.cartBrandTokens;
    var queryParams = ConductorComponentQueryParameters.build({
        surface: surface,
        cart_token: cartToken,
        brand_tokens: cartBrandTokens,
        shipping_address_token: address === null || address === void 0 ? void 0 : address.token
    });
    var conductorData = useConductorComponent(_object_spread({}, queryParams));
    return conductorData;
};
export var useConductorComponent = function(_param) {
    var componentToken = _param.componentToken, parameters = _object_without_properties(_param, [
        "componentToken"
    ]);
    var _data_component_sdui_component, _data_component, _data_component_builder_component, _data_component1, _data_component2, _data_component3;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var queryParams = ConductorComponentQueryParameters.build(parameters);
    var conductorComponentFromToken = useGetConductorComponentFromToken(componentToken !== null && componentToken !== void 0 ? componentToken : "", {
        enabled: !!componentToken
    });
    var conductorComponentFallback = useGetConductorComponentQuery(queryParams, {
        enabled: isLoggedInRetailer && !!queryParams,
        staleTime: Infinity,
        gcTime: Infinity
    });
    var activeConductorComponent = componentToken ? conductorComponentFromToken : conductorComponentFallback;
    var data = activeConductorComponent.data, isPending = activeConductorComponent.isPending;
    var conductorSduiViewLayout = data === null || data === void 0 ? void 0 : (_data_component = data.component) === null || _data_component === void 0 ? void 0 : (_data_component_sdui_component = _data_component.sdui_component) === null || _data_component_sdui_component === void 0 ? void 0 : _data_component_sdui_component.view_layout;
    var conductorBuilderModelName = data === null || data === void 0 ? void 0 : (_data_component1 = data.component) === null || _data_component1 === void 0 ? void 0 : (_data_component_builder_component = _data_component1.builder_component) === null || _data_component_builder_component === void 0 ? void 0 : _data_component_builder_component.builder_model_name;
    var shouldShowConductor = !!conductorSduiViewLayout || !!conductorBuilderModelName;
    // feature name is used in useSiteBannersList hook to identify banner type
    var featureName = data === null || data === void 0 ? void 0 : (_data_component2 = data.component) === null || _data_component2 === void 0 ? void 0 : _data_component2.feature_name;
    return {
        componentToken: data === null || data === void 0 ? void 0 : (_data_component3 = data.component) === null || _data_component3 === void 0 ? void 0 : _data_component3.token,
        shouldShowConductor: shouldShowConductor,
        conductorSduiViewLayout: conductorSduiViewLayout,
        conductorBuilderModelName: conductorBuilderModelName,
        isConductorComponentPending: isPending,
        featureName: featureName
    };
};
